import React from "react";
import {
	DiscordAuthToken,
	GetGuildRolesAndChannelsResult,
	GuildData,
} from "../../../common/sesh_types";

/**
 * User data from Discord API
 */
export interface UserData {
	id: string;
	username: string;
	discriminator: string;
	avatar_uri: string;
	email?: string;
}

/**
 * Context for current user data and auth token
 */
export const UserContext = React.createContext<UserData & DiscordAuthToken>(
	undefined
);

/**
 * Context for guild roles and channels cache
 */
export const GuildRolesAndChannelContext =
	React.createContext<Map<string, GetGuildRolesAndChannelsResult>>(undefined);

/**
 * Context for the list of guilds the user has access to
 */
export const GuildListContext = React.createContext<GuildData[]>([]);
